<template>
    <div class="body d-flex py-lg-3 py-md-2">
      <div class="container-xxl">
        <!-- Existing Content -->
        <div class="row clearfix">
          <div class="col-md-12">
            <div class="card border-0 mb-2 no-bg">
              
            </div>
          </div>
        </div>
    
        <!-- requests Table -->
        <div class="row clearfix g-3">
          <div class="col-sm-12">
            <div class="mb-3 d-flex justify-content-end">
  <button type="button" class="btn btn-success me-2" @click="bulkAcceptOtherRequests">Accept Selected</button>
  <button type="button" class="btn btn-danger me-2" @click="bulkRejectOtherRequests">Reject Selected</button>
<!--   <button type="button"  style="color:var(--secondary-color);" class="btn" data-bs-toggle="modal" data-bs-target="#addRequestModal">
    <i class="icofont-plus me-2 fs-6"></i> Days Off
  </button> -->
</div>
            <div class="card mb-3">
              <div class="card-body table-responsive" style="width: 95%; margin: 0 auto">
                
                <table id="myProjectTable" class="table table-hover align-middle mb-0 mis_table" style="width: 100%">
                  <thead>
                    <tr>
                      <th style="width:3%;" v-if="superUser">
  <input type="checkbox" @change="toggleSelectAll($event)" v-model="selectAll" />
</th>

                      <th style="width:6%;" v-if="superUser">
                      <div  class="d-flex align-items-center">
                        <select class="ms-1 nav-link rounded" name="" id="dropdownManagers"
                          @change="updateManagerFilter">
                          <option value="" selected>User</option>
                          <option v-for="manager in managers" :key="manager.id"
                              :value="manager.id">
                              {{ manager.username }}
                          </option>
                        </select>
                        <img class="menu-img" src="../assets/images/icons8-superman.svg"
                                                        alt="Citrine Logo" style="width:2em" >
                      </div>
                      
                    </th>
                      <th style="width:8%;"><div>Date</div></th>
                      <th style="width:8%;"><div>From</div></th>
                      <th style="width:8%;"><div>To</div></th>
                      <th style="width:16%;"><div>Reason</div></th>
                 <th style="width:6%; background-color:white; border:none" class=no-after><div>Actions</div></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(requests, index) in data" :key="requests.id" :class="{ 'approved': requests.approved === 1, 'not-approved': requests.approved === 0 }">
                      <td  v-if="superUser" >
  <input type="checkbox" v-model="selectedRequests" :value="requests.id" v-if="requests.approved === null"/>
</td>
                      <td>{{ requests.user?.username }}</td>
                      <td>{{ requests.request_date_formatted }}</td>
                      <td>{{ requests.from_time }}</td>
                      <td>{{ requests.to_time }}</td>
                      <td>{{ requests.description }}</td>
                     
                    <td>
  <template v-if="requests.approved === null">
    <div class="d-inline-flex">
      <button type="button" class="btn btn-secondary me-1" @click="acceptRequest(requests.id)" title="Accept">
        <i class="icofont-tick-mark text-white"></i>
      </button>
      <button type="button" class="btn btn-secondary" @click="rejectRequest(requests.id)" title="Reject">
        <i class="icofont-close text-white"></i>
      </button>
    </div>
  </template>
</td>

                    </tr>
                    <tr v-if="!data || !data.length">
                        <td colspan="100">No data</td>
                    </tr>
                  </tbody>
                </table>
                <nav aria-label="Page navigation" v-if="data && data.length">
                  <ul class="pagination mt-4" v-if="paginationLinks && paginationLinks.length > 0">
                    <li class="page-item" v-for="(paginationLink, index) in paginationLinks" :key="index" :class="{ active: paginationLink.active }">
                      <router-link :to="{ path: 'other-requests', query: { ...filters, page: getPageFromUrl(paginationLink.url) } }" v-if="paginationLink.url">
                        <span class="page-link" v-html="paginationLink.label"></span>
                      </router-link>
                      <span class="page-link" v-else v-html="paginationLink.label"></span>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
  
        <!-- Accept Day Off Modal -->
        <div class="modal fade" id="accept-requests-form" tabindex="-1" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title fw-bold" id="acceptrequestsLabel">Accept Request?</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <input name="id" id="id" type="hidden" v-model="requestsData.id" />
                <div class="mb-3">
                  Are you sure you want to accept this request?
                </div>
              </div>
              <div class="modal-footer">
<!--                 <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
 -->                <button type="button" class="btn btn-secondary" @click="confirmAcceptRequest">Accept</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Reject Day Off Modal -->
        <div class="modal fade" id="reject-requests-form" tabindex="-1" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title fw-bold" id="acceptrequestsLabel">Reject Request?</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <input name="id" id="id" type="hidden" v-model="requestsData.id" />
                <div class="mb-3">
                    Are you sure you want to reject this request?
                </div>
              </div>
              <div class="modal-footer">
<!--                 <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
 -->                <button type="button" class="btn btn-secondary" @click="confirmRejectRequest">Reject</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Add Days Off Modal -->
        <div class="modal fade" id="addRequestModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
        <h5 class="modal-title fw-bold">Add Days Off  <img src="../assets/images/icons8-superman.svg"
                                                            alt="Citrine Logo" class="menu-img ms-1 managerProfIcon"
                                                            style="width:.1.5em"></h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        
        <table class="table table-striped">
          <thead>
            <tr>
              <th class="d-flex" style="width:30%"><input type="checkbox" @change="toggleAllUsers" v-model="allUsersSelected" class="me-2"><span style="margin-top: 1px;">Select All</span></th>
              <th>Username</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user.id">
              <td><input type="checkbox" v-model="bulkRequest.selectedUsers" :value="user.id" /></td>
              <td>{{ user.text }}</td>
            </tr>
          </tbody>
        </table>
     
      <div class="deadline-form">
                <div class="row g-3 mb-1">
                  <div class="col">
    <label for="from" class="form-label">Start Date</label>
    <input
      type="date"
      class="form-control"
      id="from"
      v-model="bulkRequest.from"
      :min="today" 
      placeholder="Start Date"
    />
  </div>
                  <div class="col">
                    <label for="to" class="form-label">End Date</label>
                    <input type="date" class="form-control" id="to" v-model="bulkRequest.to" placeholder="End Date" :min="bulkRequest.from || today" >
                  </div>
                </div>
              </div>
              <div class="mb-1">
                <label for="description" class="form-label">Reason</label>
                <textarea class="form-control" id="description" rows="3" v-model="bulkRequest.description" placeholder="Reason"></textarea>
              </div> </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="submitBulkRequest">Submit</button>
      </div>
    </div>
  </div>
</div>


      </div>
    </div>
  </template>
  
  <script>
import { ref, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useFetchData } from '@/composables/useFetchData';
import { fetchOtherRequests, accept, reject, multaccept, multreject  } from '@/services/other-requests';
import { useToast } from 'vue-toastification';
import { mapGetters } from 'vuex';
import { fetchManagers } from '@/services/followup';
import { getClientsServicesStatusesUsers } from '@/services/projects';

const defaultrequestsData = {
  id: '',
  user: '',
  from: '',
  to: '',
  description: ''
};

export default {
  name: 'DaysOff',
  computed: {
        ...mapGetters({
            getUserPermission: 'getUserPermission',
            getSuperUserPermission: 'getSuperUserPermission',

        }),
        superUser() {
            return this.getSuperUserPermission === 1;
        },
       
    },
  setup() {
    const route = useRoute();
    const toast = useToast();
    const managers = ref([]);
    const allData = ref({ users: [], clients: [], statuses: [], services: [] });
    const bulkRequest = ref({
  from: '',
  to: '',
  selectedUsers: [],
});
const users = computed(() => allData.value.users);
const allUsersSelected = ref(false);

const toggleAllUsers = () => {
  if (allUsersSelected.value) {
    bulkRequest.value.selectedUsers = users.value.map(u => u.id);
  } else {
    bulkRequest.value.selectedUsers = [];
  }
};

const submitBulkRequest = async () => {
  if (!bulkRequest.value.from || !bulkRequest.value.to || !bulkRequest.value.description || bulkRequest.value.selectedUsers.length === 0) {
    toast.error('Please select users, date range and reason.');
    return;
  }

  try {
    const res = await createBulkRequest(bulkRequest.value);
    if (res.data.success) {
      toast.success(res.data.message);
      $('#addRequestModal').modal('hide');
      $('body').removeClass('modal-open');
$('.modal-backdrop').remove();
      fetchData(); // Refresh your main table
      // Reset
      bulkRequest.value = { from: '', to: '', selectedUsers: [] };
      allUsersSelected.value = false;
    } else {
      toast.error(res.data.message);
    }
  } catch (error) {
    toast.error('Error submitting requests.');
  }
};
    const selectedRequests = ref([]);
    const selectAll = ref(false);

    // Toggle all checkboxes
    const toggleSelectAll = (event) => {
  if (event.target.checked) {
    // Only select requests where 'approved' is null
    selectedRequests.value = data.value.filter((request) => request.approved === null).map((request) => request.id);
  } else {
    selectedRequests.value = [];
  }
};


    // Bulk Accept Function
    const bulkAcceptOtherRequests = async () => {
      if (selectedRequests.value.length === 0) {
        toast.warning('No requests selected.');
        return;
      }
      try {
        const response = await multaccept({ ids: selectedRequests.value });
        if (response.data.success) {
          toast.success(response.data.message);
          selectedRequests.value = [];
          fetchData();
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error('Error processing request.');
      }
    };

    // Bulk Reject Function
    const bulkRejectOtherRequests = async () => {
      if (selectedRequests.value.length === 0) {
        toast.warning('No requests selected.');
        return;
      }
      try {
        const response = await multreject({ ids: selectedRequests.value });
        if (response.data.success) {
          toast.success(response.data.message);
          selectedRequests.value = [];
          fetchData();
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error('Error processing request.');
      }
    };

    const { data, paginationLinks, filters, updateFilters, fetchData, sortBy } = useFetchData(fetchOtherRequests, { page: route.query.page || 1 }, { page: 1 });

    const requestsData = ref(defaultrequestsData);

    const fetchManagersData = async () => {
            try {
                const response = await fetchManagers();
                if (response.data.success) {
                    managers.value = response.data.data;
                }
            } catch (error) {
                console.error('Failed to fetch managers:', error);
            }
        };

        const updateManagerFilter = (event) => {
            const newManagerId = event.target.value;
            updateFilters({ ...filters.value, userFilter: newManagerId, page: 1 });
        };

    const acceptRequest = (id) => {
      requestsData.value.id = id;
      $('#accept-requests-form').modal('toggle');
    };

    const rejectRequest = (id) => {
      requestsData.value.id = id;
      $('#reject-requests-form').modal('toggle');
    };

    const confirmAcceptRequest = async () => {
      try {
        const response = await accept(requestsData.value);
        if (response.data.success) {
          toast.success(response.data.message);
          $('#accept-requests-form').modal('toggle');
          fetchData();
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error('Error submitting form');
      }
    };

    const confirmRejectRequest = async () => {
      try {
        const response = await reject(requestsData.value);
        if (response.data.success) {
          toast.success(response.data.message);
          $('#reject-requests-form').modal('toggle');
          fetchData();
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error('Error submitting form');
      }
    };

    const getPageFromUrl = (url) => {
      if (!url) return null;
      const urlObj = new URL(url, window.location.origin);
      return urlObj.searchParams.get('page');
    };

    onMounted(async () => {
      await fetchData();
      fetchManagersData();
      const tmpAllData = await getClientsServicesStatusesUsers({ params: { type: "subtasks" } });
                let newData = { users: [], statuses: [], clients: [], services: [] };

                for (let i = 0; i < tmpAllData.data.users.length; i++) {
                    newData.users.push({ id: tmpAllData.data.users[i].id, text: tmpAllData.data.users[i].username });
                }
                for (let i = 0; i < tmpAllData.data.statuses.length; i++) {
                    newData.statuses.push({ id: tmpAllData.data.statuses[i].id, text: tmpAllData.data.statuses[i].description });
                }
                for (let i = 0; i < tmpAllData.data.clients.length; i++) {
                    newData.clients.push({ id: tmpAllData.data.clients[i].id, text: tmpAllData.data.clients[i].title });
                }
                for (let i = 0; i < tmpAllData.data.services.length; i++) {
                    newData.services.push({ id: tmpAllData.data.services[i].id, text: tmpAllData.data.services[i].title });
                }

                allData.value = newData; // `allData` is a ref, so use `.value`

    });

    return {
      data,
      paginationLinks,
      filters,
      updateFilters,
      fetchData,
      requestsData,
      getPageFromUrl,
      acceptRequest,
      confirmAcceptRequest,
      rejectRequest,
      confirmRejectRequest, sortBy,
      updateManagerFilter, managers,
      selectedRequests,
      selectAll,
      toggleSelectAll,
      bulkAcceptOtherRequests,
      bulkRejectOtherRequests,toggleAllUsers, submitBulkRequest, bulkRequest, users,
      allUsersSelected,
    };
  },
  metaInfo: {
    title: 'Other Requests',
    meta: [
      { name: 'description', content: 'MIS - Other Requests' },
      { property: 'og:title', content: 'MIS - Other Requests' },
      { property: 'og:description', content: 'This is the other requests page.' }
    ]
  }
};
</script>

  
  <style scoped>
  .dropdown-menu.show {
    display: block;
  }
  
  .approved{
  background-color: rgb(107, 219, 107);
}

.not-approved{
  background-color: rgb(241, 111, 111);
}
</style>

  